import { Takk, takkSchema } from "@mjolnerbacken/shared/types/takk";

import { getRequest, patchRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getTakkToday(code?: string): Promise<Takk[]> {
  return await getRequest<Takk[]>(
    `${API_BASE_URL}/takk-today${code ? `?asRoot= true&code=${code}` : ""}`,
    takkSchema.array(),
  );
}

export async function updateTakkToday(takkIds: string[]): Promise<void> {
  await patchRequest<Takk[]>(`${API_BASE_URL}/takk-today`, { takk: takkIds });
}
